export default "__VITE_ASSET__D$J_0wky__"